module.exports = __webpack_public_path__ + "media/images/default/shared/header/main-xl-5714f7c5fbe5e433f1dfa1151012b079.jpg";